<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="pt1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">ENGLAND 1878</span></p>
<p class="sp"> </p>
<p class="Part-Opening-Text-No-Indent-potx1"><span class="Script">Sometimes, </span>in this big, cold house, I pretend I am an explorer on an expedition, navigating the long corridors like rivers, the huge rooms like undiscovered islands. I crawl under tables and leap onto sofas. I take my sister’s hand, and we run through the rooms together. But the air next to my body is cold because she isn’t really there, and when I look at the empty space next to me, my chest hurts. It hurts right where my heart is, so I think that this must be what is meant by a broken heart.</p>
<p class="Text-Standard-tx">“Why,” I ask Maman, “is everything different?”</p>
<p class="Text-Standard-tx">She puts her hands on my cheeks and looks at me with eyes that are so soft and brown I wish I could touch them.</p>
<p class="Text-Standard-tx">“You are just a boy,” she says. “It is too much for a boy to understand.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?1ce6d22c